<template>
  <div class="dialogContainer">
    <el-dialog
      :title="title"
      :width="width"
      :modal="true"
      center
      :destroy-on-close="true"
      :visible="visible"
      @close="handleClose"
    >
      <!-- 内容插槽 -->
      <slot></slot>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="canecl_btn" @click="handleCancel">取 消</el-button>
        <el-button class="confirm_btn" type="primary" @click="handleConfirm"
          >确 认</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'retrievePassword',
  props: {
    title: {
      type: String
    },
    width: {},
    visible: {
      type: Boolean,
      require: true
    }
  },

  mounted () {},
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    handleCancel () {
      this.$emit('cancel')
    },
    handleConfirm () {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
.dialogContainer ::v-deep .el-dialog__wrapper {
  overflow: hidden;
  top: 0;
  display: flex;
  align-items: center;
}
.dialogContainer ::v-deep .el-dialog {
  margin-top: 50px !important;
}

// ::v-deep .el-dialog {
//   border: 2px solid #4b669a;
//   border-radius: 10px;
//   overflow: hidden;
//   margin-top: 30px !important;
// }
// ::v-deep .el-dialog__header {
//   text-align: left;
//   background-color: #001656;
//   padding: 20px;
// }
// ::v-deep .el-dialog__title {
//   font-size: 24px;
//   line-height: 24px;
//   font-family: PingFang SC-Semibold, PingFang SC;
//   font-weight: 600;
//   color: #fff;
// }

// ::v-deep .el-dialog__body,
// ::v-deep .el-dialog__footer {
//   border-top: 2px solid #192d67;
//   background-color: #001656;
//   padding: 30px;
// }
// .canecl_btn {
//   background-color: #4f5c83;
//   color: #fff;
//   border: none;
// }
// .confirm_btn {
//   background-color: #5b83fb;
//   border: none;
//   color: #fff;
// }
</style>
